import React, { useState } from "react";
import { Tabs, Card } from "antd";
import { WalletOutlined, AppstoreOutlined } from "@ant-design/icons";
import GestionCategoriesDepenses from "../../gestion-depenses/GestionCategoriesDepenses";
import GestionSaisieDepenses from "../../gestion-depenses/GestionSaisieDepenses";

const { TabPane } = Tabs;

const LOGISTICS_EXPENSE_PERMISSIONS = {
  categories: {
    VIEW: "logistics.expenses.categories.view",
    EDIT: "logistics.expenses.categories.edit",
    DELETE: "logistics.expenses.categories.delete",
  },
  entries: {
    VIEW: "logistics.expenses.entries.view",
    CREATE: "logistics.expenses.entries.create",
    EDIT: "logistics.expenses.entries.edit",
    DELETE: "logistics.expenses.entries.delete",
    EXPORT: "logistics.expenses.entries.export",
    CREATE_PAYMENT: "logistics.expenses.entries.create_payment",
  },
};

const LogisticsExpenses: React.FC = () => {
  const [activeTab, setActiveTab] = useState("entries");

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          Charges Admin
        </h1>
        <p className="text-gray-600">
          Suivi des catégories et saisie des charges admin de
          l'activité.
        </p>
      </div>

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          size="large"
          type="card"
        >
          <TabPane
            tab={
              <span>
                <WalletOutlined /> Saisie
              </span>
            }
            key="entries"
          >
            <GestionSaisieDepenses
              moduleScope="logistics"
              permissions={LOGISTICS_EXPENSE_PERMISSIONS.entries}
              title="Saisie des Charges Admin"
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                <AppstoreOutlined /> Categories
              </span>
            }
            key="categories"
          >
            <GestionCategoriesDepenses
              moduleScope="logistics"
              permissions={LOGISTICS_EXPENSE_PERMISSIONS.categories}
              title="Gestion des Categories de Charges Admin"
            />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default LogisticsExpenses;
